import Menu from './menu';
import Arc from './arc';
import Foot from './foot';

const menu = new Menu();
const arc = new Arc();
const foot = new Foot();

export default {
    menu,
    arc,
    foot
}